const rolesMap = (access: string) => {
  switch(access) {
    case 'admin':
      return 'مدیر سیستم';
    case 'crm':
    case 'company':
      return 'پشتیبان سیستم';
    case 'customer':
      return 'کاربر سیستم';
    case 'sub-customer':
      return 'سوپروایزر';
  }
}

export default rolesMap;
